import {
  Box,
  CircularProgress,
  Container,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import * as yup from "yup";
import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import CustomButton from "../../../../Components/Button/CustomButton";
import backbluebtn from "../../../../Utils/Images/backbluebtn.png";
import gallary from "../../../../Utils/Images/Gallerywhite.png";
import CustomInput from "../../../../Components/input/CustomInput";
import { GetSingleRecipe } from "../../../../APIs/Function/Workout/Recipe/GetSIngleRecipe";
import { handleUpdateRecipe } from "../../../../APIs/Function/Workout/Recipe/EditRecipe";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
const EditRecipe = () => {
  const validationSchema = yup.object().shape({
    title: yup.string().trim().required("Title is required"),
    description: yup.string().trim().required("Description is required"),
    recipe_type: yup.string().required("Recipe type is required"),
  });

  const [previewImage, setPreviewImage] = useState(null);
  const [loadinga, setLoadinga] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [imagea, setimagea] = useState([]);
  const [removedImages, setRemovedImages] = useState([]);
  const [formData, setFormData] = useState({
    title: "",
    description: "",
    recipe_type: "",
    images: previewImage,
  });

  const initialFormData = {
    title: "",
    description: "",
    recipe_type: "",
    images: null,
  };

  const [singleRecipe, setSingleRecipe] = useState({});
  const { id } = useParams();

  const handleSingleRecipe = async () => {
    try {
      setLoading(true);
      let res = await GetSingleRecipe(id);
      setSingleRecipe(res.r);
      setFormData({
        ...formData,
        title: res.r.title,
        description: res.r.description,
        recipe_type: res.r.recipe_type,
        images: res.r.recipe_images,
      });
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    handleSingleRecipe();
  }, []);


  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  const removePreviewImage = (index) => {
    const updatedPreviewImage = [...previewImage];
    updatedPreviewImage.splice(index, 1);
    setPreviewImage(updatedPreviewImage);
  };

  const removeMainImage = (index) => {
    const updatedImages = [...singleRecipe.recipe_images];
    const removedImage = updatedImages.splice(index, 1)[0];
    setSingleRecipe({
      ...singleRecipe,
      recipe_images: updatedImages,
    });
    if (removedImage.id) {
      setRemovedImages([...removedImages, removedImage]);
    }
  };

  const blobToFile = (blob, name) => {
    const file = new File([blob], name, { type: blob.type });
    return file;
  };
  const handleSubmit = async () => {
    // Create an array to hold both existing and new images
    const updatedImages = [...singleRecipe.recipe_images, ...imagea];
    const updatedFormData = {
      ...formData,
      images: updatedImages,
    };
  
    if (removedImages.length > 0) {
      updatedFormData.remove_photos = removedImages.map((removedImage) => removedImage.id);
    }
  
    // Check if there is at least one image selected or after removing images
    if (!updatedFormData.images || updatedFormData.images.length === 0) {
      alert("Please select at least one image before saving.");
      return; // Exit the function without submitting the form
    }
  
    try {
      await validationSchema.validate(updatedFormData, { abortEarly: false });
      setLoadinga(true);
      await handleUpdateRecipe(updatedFormData, id);
  
      setFormData(initialFormData);
      setPreviewImage([]);
      setimagea([]);
      setRemovedImages([]);
      setLoadinga(false);
      alert("Recipe Edited Successfully");
      navigate("/recipeplans");
    } catch (error) {
      if (error.name === "ValidationError") {
        // Handle validation errors
      } else {
        console.log(error);
        setLoading(false);
      }
    }
  };
  
  
  

  const handleFileChange = (event) => {
    const selectedFiles = event.target.files;
    const fileObjects = [];
    for (let i = 0; i < selectedFiles.length; i++) {
      const objectURL = URL.createObjectURL(selectedFiles[i]);
      const file = blobToFile(selectedFiles[i], selectedFiles[i].name);
      fileObjects.push(file);
    }
    setPreviewImage(fileObjects);
    setimagea(fileObjects);

    setFormData({
      ...formData,
      images: fileObjects,
    });
  };

  return (
    <>
      {loading ? (
        <Box sx={{ mt: "25%" }}>
          <CircularProgress></CircularProgress>
        </Box>
      ) : (
        <Box>
          <Box
            sx={{
              bgcolor: "#31AEF4",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              height: { xs: "50px", md: "70px", lg: "70px" },
              p: "10px",
              boxSizing: "border-box",
            }}
          >
            <Link to={"/recipeplans"}>
              <Box
                sx={{
                  height: { xs: "50px", md: "60px", lg: "60px" },
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <img height={"100%"} src={backbluebtn} alt="back" />
              </Box>
            </Link>
            <Box>
              <Typography
                sx={{
                  fontFamily: "Open Sans",
                  fontSize: { md: "30px", sm: "20px" },
                  fontWeight: 600,
                  lineHeight: "36px",
                  color: "#FFFFFF",
                }}
              >
                Edit Recipe
              </Typography>
            </Box>
            <Box>
              <CustomButton
                onClick={handleSubmit}
                sx={{
                  width: { xs: "40px", md: "50px", lg: "80px" },
                  height: { xs: "10px", md: "50px", lg: "50px " },
                }}
              >
                {loadinga ? <CircularProgress></CircularProgress> : "Save"}
              </CustomButton>
            </Box>
          </Box>
          <Box
            sx={{
              p: 2,
              boxSizing: "border-box",
              display: "flex",
              justifyContent: "center ",
            }}
          >
            {/* Form */}
            <Box
              sx={{
                mt: "10px",
                border: "1px solid #E8E8E8",
                width: "45%",
                boxSizing: "border-box",
                p: 2,
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between ",
                  alignItems: "center",
                  boxSizing: "border-box",
                  p: 1,
                }}
              >
                <Box>
                  <Typography
                    sx={{
                      fontFamily: "inter",
                      fontWeight: 400,
                      fontSize: "20px",
                      lineHeight: "20px",
                    }}
                  >
                    Gallary
                  </Typography>
                </Box>
                <Box>
                  <label htmlFor="file-input">
                    <Box
                      sx={{
                        display: "flex",
                        bgcolor: "#000000",
                        height: "50px",
                        gap: "5px ",
                        alignItems: "center",
                        borderRadius: "5px",
                        p: 2,
                        boxSizing: "border-box",
                        cursor: "pointer",
                      }}
                    >
                      <Typography
                        sx={{
                          color: "#FFFFFF",
                          fontFamily: "inter",
                          fontWeight: 400,
                          fontSize: "16px",
                          lineHeight: "16px",
                        }}
                      >
                        Upload Image
                      </Typography>
                      <Box sx={{ width: "25px", height: "25px" }}>
                        <img width={"100%"} src={gallary} alt="gallary" />
                      </Box>
                    </Box>
                  </label>
                  <input
                    accept="image/*"
                    type="file"
                    id="file-input"
                    multiple
                    onChange={handleFileChange}
                    style={{ display: "none" }}
                  />
                </Box>
              </Box>
              <Box sx={{ display: "flex", gap: "20px", flexWrap: "wrap" }}>
                {singleRecipe?.recipe_images?.map((e, i) => (
                  <Box
                    sx={{
                      width: "100px",
                      height: "100px",
                      position: "relative",
                    }}
                  >
                    <img
                      width={"100%"}
                      height={"100%"}
                      src={`https://api-qhealth.equitysofttechnologies.com/upload/images/${e.r_images}`}
                      alt=""
                    />
                    <HighlightOffIcon
                      sx={{
                        position: "absolute",
                        ml: "-25px",
                      }}
                      onClick={() => removeMainImage(i)}
                    />
                  </Box>
                ))}
              </Box>

              <Box sx={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
                {previewImage
                  ? previewImage.map((e, i) => (
                      <Box
                        sx={{
                          width: "100px",
                          height: "100px",
                          position: "relative",
                          mt: "10px",
                        }}
                      >
                        <img
                          style={{ borderRadius: "10px" }}
                          width={"100%"}
                          height={"100%"}
                          src={URL.createObjectURL(e)}
                          alt="preview"
                        />
                        <HighlightOffIcon
                          sx={{
                            position: "absolute",
                            ml: "-25px",
                          }}
                          onClick={() => removePreviewImage(i)}
                        />
                      </Box>
                    ))
                  : ""}
              </Box>
            </Box>
            <Box sx={{ width: "45%" }}>
              <Container maxWidth="sm" sx={{ mt: "10px" }}>
                <form onSubmit={handleSubmit}>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <CustomInput
                        label="Title"
                        name="title"
                        value={formData.title}
                        onChange={handleInputChange}
                        fullWidth
                        required
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <CustomInput
                        label="Description"
                        name="description"
                        value={formData.description}
                        onChange={handleInputChange}
                        fullWidth
                        multiline
                        rows={4}
                        required
                      />
                    </Grid>
                    <Grid item xs={12} sx={{ mt: "15px" }}>
                      <FormControl fullWidth required>
                        <InputLabel
                          htmlFor="recipe-type-select"
                          sx={{
                            backgroundColor: "#FFF",
                          }}
                        >
                          Recipe Type
                        </InputLabel>
                        <Select
                          name="recipe_type"
                          value={formData.recipe_type}
                          onChange={handleInputChange}
                          sx={{
                            textAlign: "left",
                          }}
                        >
                          <MenuItem value={1}>Morning</MenuItem>
                          <MenuItem value={2}>Afternoon</MenuItem>
                          <MenuItem value={3}>Evening</MenuItem>
                          <MenuItem value={4}>Anytime</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                  </Grid>
                </form>
              </Container>
            </Box>
          </Box>
        </Box>
      )}
    </>
  );
};

export default EditRecipe;
